import React, { useEffect, useState } from "react";
import "./OrderList.scss";
import { ICartListInfo } from "../../interface/ICart";

import { IBusinessInfo } from "../../interface/IBusiness";
import { convertDateOfDateToStringFormat, convertDateToStringFormat } from "../../actions/common";
import { useTranslation } from "react-i18next";
import { setDecimalValWithCurrencyLang } from "../../actions/priceFormatter";
import { getTranslationsLang } from "../../reducers/translations";
import { useSelector } from "react-redux";

type Props = {
    carts: ICartListInfo[] | [];
    business: IBusinessInfo;
    cartDateSelector?: Date | Date[] | undefined;
    onGoToCart: (cart: ICartListInfo) => void;
};

const OrderList: React.FC<Props> = props => {
    const [cart_list, setCartList] = useState<ICartListInfo[]>([]);
    const { t, i18n } = useTranslation('common');
    const localLang = useSelector(getTranslationsLang);

    //setStatuses
    useEffect(() => {
        setCartList(props.carts);
    }, [props.carts])

    const gotoCart = (cart: ICartListInfo) => {
        props.onGoToCart(cart);

    }

    return (
        <>
            {cart_list && cart_list.length > 0 && cart_list.map((cart: ICartListInfo) => (
                <div className="card cart-default-selection-card shadow-1" onClick={() => gotoCart(cart)} key={cart.id + "_" + cart.isLateOrder + "_" + cart.soAmend}>
                    <div className="flex justify-content-between  mb-2">
                        <div >
                            <span className="list-title p-text-default">
                                {(cart.isLateOrder || cart.isLate) && <span>{t('LateOrder')}</span>}
                                {(!cart.isLateOrder && !cart.isLate) && <span>{t('Cart')}</span>}
                            </span>
                            <div>
                                {cart.updatedByName}
                            </div>
                            <div>
                                {cart.date && <>
                                    {convertDateOfDateToStringFormat(cart.date, props.business.dateFormat)}
                                </>
                                }
                            </div>
                            <div>
                                {cart.note}
                            </div>
                            <div>
                                {cart.purchaseOrderNr}
                            </div>
                        </div>

                        <div className="mb-2 mr-2">
                            {cart.total ?
                                <span className="list-cost">
                                    {setDecimalValWithCurrencyLang(cart.total, localLang, props.business, false)}

                                </span> : <>
                                </>}
                        </div>

                    </div>
                </div>
            ))}

        </>
    )
}

export default OrderList;


